import { render, staticRenderFns } from "./MpDataDub.vue?vue&type=template&id=69c435ff&scoped=true&"
import script from "./MpDataDub.vue?vue&type=script&lang=js&"
export * from "./MpDataDub.vue?vue&type=script&lang=js&"
import style0 from "./MpDataDub.vue?vue&type=style&index=0&id=69c435ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c435ff",
  null
  
)

export default component.exports